import React from 'react'

import "./VideoModal.style.css";

function VideoModal({url, onClose}) {
    return (
        <div className="video-modal" onClick={onClose}>
            <div className="video-container">
                <iframe className="frame" src={url} title="Video" type="text/html" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture;" allowfullscreen></iframe>
            </div>
        </div>

    )
}

export default VideoModal
